// extracted by mini-css-extract-plugin
export default {"container":"ImageGenerator_container__8XvYn","content":"ImageGenerator_content__14VT3","text":"ImageGenerator_text__NzBbZ","downloadButton":"ImageGenerator_downloadButton__ILY59"};